import React, { createRef } from "react";
import { useExpanded, useSortBy, useTable } from "react-table";

export function BasicTableDetails({columns, data, initExpanded, renderRowSubComponent, onClickRow} = {renderRowSubComponent:(row) => row.subRows || [], onClickRow: (idx, row) => {}}) {
	const {
        getTableProps,
        getTableBodyProps,
		headerGroups,
        rows,
        prepareRow,
		visibleColumns,
		state: {expanded}
    } = useTable(
        {
            columns,
            data,
			initialState:{
				expanded: initExpanded
			}
        },
        useSortBy,
		useExpanded
    )
	const toggleExpanded = (row) => {
		onClickRow(row);
        row.toggleRowExpanded();
	}
	return (
        <table {...getTableProps()} className="ReactTable -highlight primary-pagination" style={{display: 'block', overflowX: 'scroll', whiteSpace: 'nowrap', WebkitOverflowScrolling: 'touch'}}>
            <thead className="rt-thead">
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()} className="rt-tr">
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps(column.isSortDisabled == true ? "" :column.getSortByToggleProps())}
                                className={"rt-th" + (column.isSortDisabled == true ? "" : " -cursor-pointer") +" text-center rt-resizable-header-content " +
                                    (column.isSorted
                                        ? column.isSortedDesc
                                            ? '-sort-desc'
                                            : '-sort-asc'
                                    : '')}
                                style={{width: `${column.width + (column.headerLabel == '□' ? 10 : 0)}px`, minWidth: `${column.width + (column.headerLabel == '□' ? 10 : 0)}px`, maxWidth: `${column.width + (column.headerLabel == '□' ? 10 : 0)}px`}}>
                                
                                <div>
                                    {column.render('Header')}
                                </div>
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()} className="rt-tbody" style={{display: 'table', width: '100%'}}>
                {rows.map((row, i) => {
                    prepareRow(row)
                    // console.log(row.original)
                    const rowColor = row.original.rowColor ? row.original.rowColor : ""
                    // let blue = row.original.isCustorder? " bg-lblue":""
					return (<>
                        <tr {...row.getRowProps()} className={row.isExpanded?"rt-tr exp " +rowColor :"rt-tr " +rowColor} style={{display: 'block'}} 
                            // onClick={() => {
							// 	row.toggleRowExpanded(); 
							// 	onClickRow({row});
							// }
						    // }
                        >
                            {row.cells.map((cell, j) => {
                                return <td {...cell.getCellProps()} className={"rt-td va-top " + (headerGroups[0].headers[j].headerLabel == '□' ? 'text-center' : '')} style={{width: `${headerGroups[0].headers[j].totalWidth + (headerGroups[0].headers[j].headerLabel == '□' ? 10 : 0)}px`, minWidth: `${headerGroups[0].headers[j].totalWidth + (headerGroups[0].headers[j].headerLabel == '□' ? 10 : 0)}px`, maxWidth: `${headerGroups[0].headers[j].totalWidth + (headerGroups[0].headers[j].headerLabel == '□' ? 10 : 0)}px`}}>
									{cell.render('Cell')}
                                    {j == 0?(
                                    <div class='bi'>
                                        <span class='ta-d' onClick={() => {toggleExpanded(row); }}> </span>
                                    </div>
                                    ):null}
								</td>
                            })}
                        </tr>
						{row.isExpanded?(<tr>
							<td colSpan={visibleColumns.length}>
                                <div class='bi bi-sub'>
                                    <span class='ta-u' onClick={() => {toggleExpanded(row); }}> </span>
                                </div>
								{renderRowSubComponent({row})}
                                {/* <div class='bi'>
                                    <span class='ta-u' onClick={() => {toggleExpanded(row); }}> </span>
                                </div> */}
							</td>
						</tr>)
						:null}
					</>)
                })}
            </tbody>
        </table>
    )
}
